// src/screens/DonorsScreen.jsx
import { useState } from "react";
import { C } from "../styles/tokens";
import { Icon, Badge, BloodBadge } from "../components/UI";
import { DONORS, BLOOD_GROUPS } from "../data/mockData";

export default function DonorsScreen() {
  const [search,      setSearch]      = useState("");
  const [filterBlood, setFilterBlood] = useState("All");
  const [filterAvail, setFilterAvail] = useState("All");

  const filtered = DONORS.filter((d) => {
    const ms = d.name.toLowerCase().includes(search.toLowerCase());
    const mb = filterBlood === "All" || d.blood === filterBlood;
    const ma =
      filterAvail === "All" ||
      (filterAvail === "Available" ? d.available : !d.available);
    return ms && mb && ma;
  });

  const availableCount = DONORS.filter((d) => d.available).length;

  return (
    <div className="fade-up" style={{ padding: 24 }}>
      {/* Summary stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14, marginBottom: 20 }}>
        {[
          { label: "Total Donors",  value: DONORS.length,               color: C.blue    },
          { label: "Available Now", value: availableCount,               color: C.green   },
          { label: "Unavailable",   value: DONORS.length - availableCount, color: C.muted },
        ].map((s) => (
          <div key={s.label} className="card" style={{ padding: 16, display: "flex", alignItems: "center", gap: 14 }}>
            <div className="syne" style={{ fontSize: 32, fontWeight: 900, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: C.muted }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16, alignItems: "center" }}>
        {/* Search */}
        <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
          <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }}>
            <Icon name="search" size={15} color={C.muted} />
          </span>
          <input
            className="inp"
            style={{ paddingLeft: 36 }}
            placeholder="Search donors..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Blood group filter */}
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {["All", ...BLOOD_GROUPS].map((g) => (
            <button
              key={g}
              className={`chip ${filterBlood === g ? "active" : ""}`}
              onClick={() => setFilterBlood(g)}
            >
              {g}
            </button>
          ))}
        </div>

        {/* Availability filter */}
        <div style={{ display: "flex", gap: 6 }}>
          {["All", "Available", "Unavailable"].map((a) => (
            <button
              key={a}
              className={`chip ${filterAvail === a ? "active" : ""}`}
              onClick={() => setFilterAvail(a)}
            >
              {a}
            </button>
          ))}
        </div>
      </div>

      {/* Donor list */}
      {filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: 60, color: C.muted }}>
          <Icon name="people" size={48} color={C.muted} />
          <p style={{ marginTop: 12, fontSize: 15 }}>No donors match your filters</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {filtered.map((d) => (
            <div
              key={d.id}
              className="card"
              style={{ padding: 18, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", borderLeft: `3px solid ${d.available ? C.green : C.border}` }}
            >
              {/* Avatar */}
              <div style={{ position: "relative" }}>
                <div style={{ width: 48, height: 48, background: "rgba(198,40,40,.15)", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, fontWeight: 900, color: C.red }}>
                  {d.name[0]}
                </div>
                <div style={{ position: "absolute", bottom: 0, right: 0, width: 12, height: 12, borderRadius: "50%", background: d.available ? C.greenL : C.muted, border: `2px solid ${C.card}` }} />
              </div>

              {/* Info */}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 15, color: C.text }}>{d.name}</div>
                <div style={{ display: "flex", gap: 14, marginTop: 4, flexWrap: "wrap" }}>
                  <span style={{ fontSize: 12, color: C.muted, display: "flex", alignItems: "center", gap: 4 }}>
                    <Icon name="location" size={11} color={C.muted} />{d.dist}
                  </span>
                  <span style={{ fontSize: 12, color: C.muted, display: "flex", alignItems: "center", gap: 4 }}>
                    <Icon name="history" size={11} color={C.muted} />Last donated {d.donated}
                  </span>
                  <span style={{ fontSize: 12, color: C.muted, display: "flex", alignItems: "center", gap: 4 }}>
                    <Icon name="drop" size={11} color={C.red} />{d.total} donations
                  </span>
                </div>
              </div>

              <BloodBadge group={d.blood} />
              <Badge label={d.available ? "Available" : "Unavailable"} color={d.available ? C.green : C.muted} />

              {/* Actions */}
              <div style={{ display: "flex", gap: 8 }}>
                {d.available && (
                  <button className="btn-sm" style={{ background: "rgba(56,142,60,.12)", color: "#4CAF50", borderColor: "rgba(56,142,60,.3)", display: "flex", alignItems: "center", gap: 6 }}>
                    <Icon name="phone" size={12} color="#4CAF50" />Call
                  </button>
                )}
                <button className="btn-sm" style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <Icon name="mail" size={12} color={C.red} />Message
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}